/** The tile grid's frame classes, shared by the editable grid and the shared view. */

/**
 * One row unit.
 *
 * Two rows is a comfortable chart, three is a tall table, and one is the strip
 * a KPI row or a note wants. Charts fill the frame they are given rather than
 * taking their own height, so this is what "height 2" *means*.
 *
 * It applies from the two-column breakpoint upward only. In a single column a
 * grid frame has nothing to align to, and a three-row frame around a
 * three-row table is just a void — so a phone gets tiles that are as tall as
 * their contents (PRD NFR-5).
 */
export const ROWS = "sm:auto-rows-[180px]";

// Written out rather than interpolated: Tailwind scans source text, so a class
// built at runtime would never make it into the stylesheet.
export const SPAN_COLUMNS: Record<number, string> = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "sm:col-span-2 lg:col-span-4",
};

export const SPAN_ROWS: Record<number, string> = {
  1: "sm:row-span-1",
  2: "sm:row-span-2",
  3: "sm:row-span-3",
};
